import emailAddresses from "email-addresses";
import currencies from '../constants/currencies';

/**
 * Created by fers on 24/09/2017.
 */

export function convertPhoneNumber(phone: string | number | null | undefined): string | null {
    if (!phone) {
        return null;
    }

    phone = String(phone).trim();
    phone = phone.replace(/^00/, "+");
    phone = phone.replace(/[^0-9\+]+/g, "");

    return phone.trim();
}

export function convertToEmail(email: string | null | undefined): string | string[] | null {
    if (!email) {
        return null;
    }

    let list = emailAddresses.parseAddressList(email);
    if (list) {
        let result: string[] = [];
        list.forEach((item: { address: string }) => {
            result.push(item.address);
        });

        if (result.length === 1) {
            return result[0];
        }
        return result;
    }

    return null;
}

export function convertCurrency(currency: string | null | undefined): any | null {
    if (!currency) {
        return null;
    }

    let currencyOptimized: string = String(currency).trim().toLowerCase();
    // flexibee specific - with code: prefix
    if (currencyOptimized.startsWith('code:')) {
        currencyOptimized = currencyOptimized.substring('code:'.length, currencyOptimized.length);
    }
    let curr = currencies[currencyOptimized];
    if (curr) {
        return curr;
    }

    return null;
}